import { render, staticRenderFns } from "./updataProgress.vue?vue&type=template&id=ad67a036&scoped=true"
import script from "./updataProgress.vue?vue&type=script&lang=js"
export * from "./updataProgress.vue?vue&type=script&lang=js"
import style0 from "./updataProgress.vue?vue&type=style&index=0&id=ad67a036&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad67a036",
  null
  
)

export default component.exports